import { api } from "@/redux/api";

import {
	CompanySize,
	CompanySizeArraySchema,
	CreateCompanySize,
} from "../../pages/ManageCompanySize/schema/company-size";

export const companySizeApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCompanySizes: builder.query<CompanySize[], void>({
			query: () => ({
				url: "company-size",
				responseSchema: CompanySizeArraySchema,
			}),
			providesTags: ["CompanySize"],
		}),
		createCompanySize: builder.mutation<CompanySize, CreateCompanySize>({
			query: (body) => ({
				url: "company-size",
				method: "POST",
				body,
			}),
			invalidatesTags: ["CompanySize"],
		}),
		updateCompanySize: builder.mutation<CompanySize, CompanySize>({
			query: (body) => ({
				url: `company-size/${body.id}`,
				method: "PATCH",
				body,
			}),
			invalidatesTags: ["CompanySize"],
		}),
		deleteCompanySize: builder.mutation<CompanySize[], number>({
			query: (id) => ({
				url: `company-size/${id}`,
				method: "DELETE",
				responseSchema: CompanySizeArraySchema,
			}),
			invalidatesTags: ["CompanySize"],
		}),
	}),
});

export const {
	useGetCompanySizesQuery,
	useCreateCompanySizeMutation,
	useUpdateCompanySizeMutation,
	useDeleteCompanySizeMutation,
} = companySizeApi;

export const companySizeApiReducer = companySizeApi.reducer;
export const companySizeApiMiddleware = companySizeApi.middleware;
